// extracted by mini-css-extract-plugin
module.exports = {"root":"ResponsiveTableBody_root__mjE1N","tableCellLeftAlign":"ResponsiveTableBody_tableCellLeftAlign__1O7DA","tableCellRightAlign":"ResponsiveTableBody_tableCellRightAlign__2u7Ur"};